  import * as ActionTypes from "../Types/ActionTypes";

  export const SalesDashboard = (
    state = {
      isLoading: false,
      salesDashboardState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.SALES_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.SALES:
        return {
          ...state,
          isLoading: false,
          salesDashboardState: action.payload,
        };

      case ActionTypes.SALES_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
